import axios from "axios";
import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";

export async function fetchBsReportsApi(params) {
    console.log("API Call - Fetching BS Reports with params: ", params);
    return await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.BS_REPORTS.GET_ALL}`,
        params
    });
}

export async function placementReportsApi(params){
    console.log("API Call - Fetching Placement Reports");
    return await axiosRequest({
        method: "GET",
        params,
        url: `${ENDPOINTS.PLACEMENT.GET_ALL}`,
    });
}

export async function fetchSubmissionsReportsApi(params) {

    return await axiosRequest({
        method:"GET",
        params,
        url:`${ENDPOINTS.SUBMISSION.GET_ALL}`
    })
    
}

export async function fetchJobsReportsApi(params) {

    return await axiosRequest({
        method:"GET",
        params,
        url:`${ENDPOINTS.SUBMISSION.GET_ALL}`
    })
    
}

export async function fetchInterviewsReportsApi(params) {

    return await axiosRequest({
        method:"GET",
        params,
        url:`${ENDPOINTS.INTERVIEW.GET_ALL}`
    })
    
}